<template>
    <my-dialog ref="dialog" title="修改密码">
        <div class="form-div">
            <el-form ref="vform" :model="vform" status-icon :rules="rules" :label-width="vform.labelWidth" :disabled="vform.disable">
                <el-form-item label="旧密码" prop="oldPassword">
                    <el-input type="password" v-model="vform.oldPassword" autocomplete="off" show-password placeholder="输入旧密码"></el-input>
                </el-form-item>
                <el-form-item label="新密码" prop="password">
                    <el-input type="password" v-model="vform.password" autocomplete="off" show-password placeholder="输入新密码"></el-input>
                </el-form-item>
                <el-form-item label="再次输入" prop="checkPassword">
                    <el-input type="password" v-model="vform.checkPassword" autocomplete="off" show-password placeholder="输入新密码"></el-input>
                </el-form-item>
                <el-form-item align="center">
                    <el-button type="danger" @click="submitForm()" :loading="submitting">提交</el-button>
                    <el-button @click="resetForm()">重置</el-button>
                </el-form-item>
            </el-form>
        </div>
    </my-dialog>
</template>

<script>
    import MyDialog from "../../commons/MyDialog";
    import {validateOldPassword, validatePassword, validatePassword2} from "../../../validator";
    import {errorMessage, loadingInstance, successMessage} from "../../../utils";
    import {changePassword, login} from "../../../data/user";

    export default {
        name: "UserChangePassword",
        components: {MyDialog},
        data() {
            return{
                submitting: false,
                vform: {
                    disable: false,
                    labelWidth: '100px',
                    oldPassword: null,
                    password: null,
                    checkPassword: null,
                },
                rules: {
                    // 注意，password 验证的时候，不要使用 blur，否则成功失败标志和查看密码提示标志冲突
                    oldPassword: [
                        { required: true, validator: validateOldPassword.bind(this), trigger: ['change'] } // 通过 bind 将 this 传入
                    ],
                    password: [
                        { required: true, validator: validatePassword.bind(this), trigger: ['change'] } // 通过 bind 将 this 传入
                    ],
                    checkPassword: [
                        { required: true, validator: validatePassword2.bind(this), trigger: ['change'] } // 通过 bind 将 this 传入
                    ]
                }
            }
        },
        methods: {
            show: function() {
                // 延时显示
                setTimeout(() => {
                    this.$refs.dialog.show();
                }, 300);
            },
            hide: function(){
                setTimeout(()=>{
                    this.$refs.dialog.hide();
                }, 600);
            },
            submitForm() {
                this.submitting = true;
                this.$refs.vform.validate(valid => {
                    if (valid) {
                        this.vform.disable = true;
                        let loading = loadingInstance();
                        changePassword(this.vform.oldPassword, this.vform.password).then((r)=>{
                            successMessage('密码已成功修改');
                            this.hide();
                        }).catch((error)=>{
                            console.error(error);
                            this.error = '网络超时，请稍后重试';
                            errorMessage(error.message);
                        }).finally(()=>{
                            this.vform.disable = false;
                            this.submitting = false;
                            loading.close();
                        });
                    } else {
                        console.log('error submit!!');
                        this.submmtting = false;
                        return false;
                    }
                });
            },
            resetForm() {
                this.$refs.vform.resetFields();
                this.error = null;
            }
        }
    }
</script>

<style scoped>

    /deep/ .dialog-content-panel {
        height: 260px;
    }

    /* 设置 form field 输入成功的图标样式 */
    /deep/ .el-icon-circle-check:before{
        color: #67C23A;
        content: "\E720";
    }

    .form-div{
        margin-top: 15px;
        width: 60%
    }

    /* mobile screen */
    @media (max-width: 540px) {
        .form-div{
            width: 90%
        }
    }

</style>



// WEBPACK FOOTER //
// src/components/user/center/UserChangePassword.vue